import * as React from 'react';
import { FormattedMessage, IntlProvider } from 'react-intl';
import styled from 'styled-components';

import { withLocale } from '../../dashboard/contexts/locale.context';
import { Condition } from '../../dashboard/enums/condition.enum';
import { conditionToColor } from '../../utils/condition-to-color.util';
import { fontWeights, grayScale } from '../inline-styles/variables';
import ScoreDot from './ScoreDot';
import { messages } from '../../../locale/messages';
import { Locale } from 'src/app/dashboard/enums/locale.enum';

interface Props {
  value: string;
  condition: Condition;
  style: React.CSSProperties;
  locale: Locale;
}

interface StLabelConditionProps {
  margin: string;
}

const StScoreDotLabel = styled.div`
  display: inline-flex;
  align-items: center;
`;

const StLabel = styled.div`
  margin-left: 32px;
`;

const StLabelName = styled.p`
  font-size: 1.25rem;
  line-height: 1.6;
  color: ${grayScale['4']};
`;

const StLabelCondition = styled.p`
  font-size: 2rem;
  font-weight: ${fontWeights.regular};
  line-height: 1.11;
  color: #ffffff;
  text-transform: capitalize;
  margin: ${(props: StLabelConditionProps) => props.margin};
`;

class ScoreDotLabel extends React.Component<Props> {
  render() {
    const { value, condition, style, locale } = this.props;

    const margin: string = condition !== Condition.Disconnected ? '0 0 0 -2px' : '0 0 0 2px';

    return (
      <IntlProvider locale={locale} messages={messages[locale]}>
        <StScoreDotLabel style={style}>
          <ScoreDot value={value} color={conditionToColor(condition)} condition={condition} />
          <StLabel>
            <StLabelName>
              <FormattedMessage id='awair_score' />
            </StLabelName>
            <StLabelCondition margin={margin}>
              <FormattedMessage id={condition} />
            </StLabelCondition>
          </StLabel>
        </StScoreDotLabel>
      </IntlProvider>
    );
  }
}

export default withLocale(ScoreDotLabel);



// WEBPACK FOOTER //
// ./src/app/ui/components/ScoreDotLabel.tsx